import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axios-Instance";
import { getLoginToken } from "../storage";
import { queryKeys } from "../react-query/constants";
import { successAlert, toastOptions } from "../utils";
import { toast } from "react-toastify";

const SERVER_ERROR = "There was an error contacting the server.";

async function createCategory(formData: any) {
  const data = await axiosInstance({
    url: "/category",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useCreateCategory() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => createCategory(formData),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.category]);
      successAlert("Category created successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function allCategory() {
  const data = await axiosInstance({
    url: "/category",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useGetCategory() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.category],
    queryFn: allCategory,
  });
  return data;
}

async function updateCategory(formData: any) {
  const data = await axiosInstance({
    url: `/category/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useUpdateCategory() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData: any) => updateCategory(formData),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries([queryKeys.user]);
      successAlert("Category updated successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}

async function deleteCategory(categoryId: string) {
  const data = await axiosInstance({
    url: `/category/${categoryId}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data;
}

export function useDeleteCategory() {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => deleteCategory(formData as any),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.category]);
      successAlert("Category deleted successfully");
    },
    onError: (error: any) => {
      const err = error?.response?.data?.error
        ? error?.response?.data?.error
        : SERVER_ERROR;
      toast.error(err, toastOptions);
    },
  });
  return { mutate, isError, error, isSuccess, reset };
}
